import { conditions, videoTag } from "helpers";
import { useEffect, useRef } from "react";
import { handleStaticVideoCanPlay, handleStaticVideoEnded, handleStaticVideoLoadedData, handleStaticVideoPause, handleStaticVideoPlay, handleStaticVideoPlaying, handleStaticVideoTimeUpdate } from "../../../../../redux/actions";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import { setVideoElementSizeInfo } from "../../../../../redux/slices/videoDataSlice";
import { ConditionName } from "../../../../../interfaces";
import { handlePageLoadTime } from "../../../../../helpers";
import { shallowEqual } from 'react-redux'

const StaticVideoTag = () => {
    const dispatch = useAppDispatch();
    const { params, ads } = useAppSelector(({ videoData: { params, ads } }) => ({ params, ads }), shallowEqual);
    useAppSelector(({ controller: { firstPlay } }) => ({ firstPlay }), shallowEqual);
    const loadingDurationRef = useRef<any>(0);
    const initialWaitingDurationRef = useRef<any>(0);
    const timerRef = useRef<any>(null);

    useEffect(() => {
        handlePageLoadTime(loadingDurationRef);
        initialWaitingDurationRef.current = Date.now();
    }, [])

    useEffect(() => {
        const handleResize = () => {
            const element: any = videoTag()?.getBoundingClientRect();
            if (element) dispatch(setVideoElementSizeInfo(element));
        }
        if (conditions(ConditionName.isFirstPlay)) handleResize();
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, [])

    return (
        <video
            autoPlay={conditions(ConditionName.hasAutoPlay)}
            id={conditions(ConditionName.isPlayingAd) ? "ad-player-tag" : "player-tag"}
            className={`pl-w-screen pl-h-screen pl-items-center pl-flex-1 ${conditions(ConditionName.isPlayingAd) && "pl-absolute z-[100000]"} ${conditions(ConditionName.isFirstPlay) && "pl-opacity-0"}`}
            onPause={handleStaticVideoPause}
            onPlay={(event) => handleStaticVideoPlay(event, timerRef)}
            onPlaying={() => handleStaticVideoPlaying(loadingDurationRef, initialWaitingDurationRef, timerRef)}
            onTimeUpdate={handleStaticVideoTimeUpdate}
            onCanPlay={handleStaticVideoCanPlay}
            onLoadedData={handleStaticVideoLoadedData}
            onEnded={handleStaticVideoEnded}
            playsInline
        >
            <source src={conditions(ConditionName.isPlayingAd) ? ads.adStreamLink : params.src} />
        </video>
    )
}

export default StaticVideoTag;